<template>
  <div class="body_center_right_media">
      <div class="body_center_right_head">提携メディア</div>
      <div class="body_center_right_content">
        <div class="body_center_right_content_item" v-for="(item,index) in list">
          <div class="body_center_right_content_img"><img :src="item.avatar" /></div>
          <div class="body_center_right_content_name">{{item.nickname}}</div>
          <div class="body_center_right_content_name_msg">{{item.sign}}</div>
          <div class="body_center_right_content_btn" @click="followFun(item.id)">フォローする</div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    components: {
    },
    data () {
      return {
        list: [{
          avatar: "http://livaia.oss-accelerate.aliyuncs.com/image/2823e1d2-f5da-4240-95e8-208f9e5dad0f.png",
          follow: false,
          gender: 1,
          id: "19",
          sign: null,
          memberGrade: {
            boyName: "Level 10",
            girlName: "Level 10",
            name: "LV10"
          },
          nickname: "邦人NAVI+"
        },
        {
          avatar: "http://livaia.oss-accelerate.aliyuncs.com/image/cc44ed0c-d67f-4355-a89b-d263acb1946b.png",
          follow: false,
          gender: 0,
          id: "3",
          sign: "☺",
          memberGrade: {
            boyName: "Level 11",
            girlName: "Level 11",
            name: "LV11"
          },
          nickname: "邦人NAVI"
        },
        {
          avatar: "http://livaia.oss-accelerate.aliyuncs.com/image/2100b447-a7b2-41a4-96ca-223b5a01fce0.png",
          follow: false,
          gender: 1,
          id: "1284",
          sign: null,
          memberGrade: {
            boyName: "Level 8",
            girlName: "Level 18",
            name: "LV8"
          },
          nickname: "インドネシア邦人NAVI"
        }]
      }
    },
    created () {
    },
    methods: {
      followFun(item){
        if(!this.$store.state.userInfo){
          this.$parent.loginResFun()
          return
        }
        let option = {
          targetId: item.id
        }
        if(!item.follow){
          json.post('/api/member/follow/follow', option).then((res) =>{
            this.list.forEach((items,index) => {
              if(item.id == items.id){
                this.list[index].follow = true
              }
            });
          })
        }else{
          json.post('/api/member/follow/unfollow', option).then((res) =>{
            this.list.forEach((items,index) => {
              if(item.id == items.id){
                this.list[index].follow = true
              }
            });
          })
        }
      },
    }
  }
</script>
<style scoped>

</style>
